const updateLinkedInUrl = ({ linkedInUrl, dispatch }) => {
  dispatch({
    type: "UPDATE_LINKEDIN_URL",
    payload: linkedInUrl
  });
  sessionStorage.setItem("linkedInUrl", linkedInUrl);
};

export default updateLinkedInUrl;
